import { createReducer, on } from '@ngrx/store';
import { ClauseVarianceAnalysisActions, GetReviewActions, WorkspacesActions } from './actions';
import { initialState } from './state';

export const featureReducer = createReducer(
  initialState,
  on(WorkspacesActions.setWorkspaces, (state, { workspaces }) => ({
    ...state,
    workspaces: workspaces,
    loadingWorkspaces: false,
  })),
  on(WorkspacesActions.loadWorkspaces, (state, {}) => ({
    ...state,
    loadingWorkspaces: true,
  })),
  on(WorkspacesActions.loadWorkspacesFail, (state, {}) => ({
    ...state,
    loadingWorkspaces: false,
  })),
  on(WorkspacesActions.createWorkspace, (state, {}) => ({
    ...state,
    creatingWorkspace: true,
    closeCreatingWorkspaceModal: false,
  })),
  on(WorkspacesActions.createWorkspaceCancel, (state, {}) => ({
    ...state,
    creatingWorkspace: false,
    closeCreatingWorkspaceModal: false,
  })),
  on(WorkspacesActions.createWorkspaceSuccess, (state, {}) => ({
    ...state,
    creatingWorkspace: false,
    closeCreatingWorkspaceModal: false,
  })),
  on(WorkspacesActions.createWorkspaceFail, (state, {}) => ({
    ...state,
    creatingWorkspace: false,
    closeCreatingWorkspaceModal: false,
  })),
  on(WorkspacesActions.createWorkspaceCancelled, (state, {}) => ({
    ...state,
    closeCreatingWorkspaceModal: true,
  })),
  on(WorkspacesActions.closeCreatingWorkspaceModal, (state, {}) => ({
    ...state,
    closeCreatingWorkspaceModal: true,
  })),
  on(WorkspacesActions.clearCreateWorkspaceCancelled, (state, {}) => ({
    ...state,
    closeCreatingWorkspaceModal: false,
  })),
  on(WorkspacesActions.deleteWorkspace, (state, {}) => ({
    ...state,
    deletingWorkspace: true,
  })),
  on(WorkspacesActions.deleteWorkspaceCancel, (state, {}) => ({
    ...state,
    deletingWorkspace: false,
  })),
  on(WorkspacesActions.deleteWorkspaceSuccess, (state, {}) => ({
    ...state,
    deletingWorkspace: false,
  })),
  on(WorkspacesActions.deleteWorkspaceFail, (state, {}) => ({
    ...state,
    deletingWorkspace: false,
  })),
  on(WorkspacesActions.getWorkspaceDetails, (state, {}) => ({
    ...state,
    loadingWorkspaceDetails: true,
  })),
  on(WorkspacesActions.setWorkspaceDetails, (state, { workspaceDetails }) => ({
    ...state,
    workspaceDetails,
    loadingWorkspaceDetails: false,
  })),
  on(WorkspacesActions.setReferenceDocument, (state, { referenceDocument }) => ({
    ...state,
    referenceDocument,
    nonReferenceDocuments:
      state.workspaceDetails?.documents.filter((doc) => doc.id !== referenceDocument?.id) || [],
  })),
  on(WorkspacesActions.renameWorkspace, (state, {}) => ({
    ...state,
    renaminWorkspace: true,
    closeRenamingWorkspaceModal: false,
  })),
  on(WorkspacesActions.renameWorkspaceCancel, (state, {}) => ({
    ...state,
    renaminWorkspace: false,
    closeRenamingWorkspaceModal: false,
  })),
  on(WorkspacesActions.renameWorkspaceSuccess, (state, {}) => ({
    ...state,
    renaminWorkspace: false,
    closeRenamingWorkspaceModal: false,
  })),
  on(WorkspacesActions.renameWorkspaceFail, (state, {}) => ({
    ...state,
    renaminWorkspace: false,
    closeRenamingWorkspaceModal: false,
  })),
  on(WorkspacesActions.renameWorkspaceCancelled, (state, {}) => ({
    ...state,
    closeRenamingWorkspaceModal: true,
  })),
  on(WorkspacesActions.closeRenamingWorkspaceModal, (state, {}) => ({
    ...state,
    closeRenamingWorkspaceModal: true,
  })),
  on(WorkspacesActions.clearRenameWorkspaceCancelled, (state, {}) => ({
    ...state,
    closeRenamingWorkspaceModal: false,
  })),
  on(ClauseVarianceAnalysisActions.analyzeClauseVariance, (state, {}) => ({
    ...state,
    analyzingClauseVariance: true,
    loadingReviewData: false,
    loadingReviewDataComplete: false,
    analyzingClauseVarianceResponse: null,
    currentReviewPageByDocumentId: {},
    totalReviewPagesByDocumentId: {},
    reviewedReviewPagesByDocumentId: {},
    pagedReviewDataByDocumentId: {},
    totalReviewPagesAllDocuments: 0,
    totalReviewedPagesAllDocuments: 0,
  })),
  on(ClauseVarianceAnalysisActions.analyzeClauseVarianceSuccess, (state, { response }) => ({
    ...state,
    analyzingClauseVariance: false,
    analyzingClauseVarianceResponse: response,
    totalReviewPagesAllDocuments: response.totalNumberOfPages,
  })),
  on(ClauseVarianceAnalysisActions.analyzeClauseVarianceFail, (state, {}) => ({
    ...state,
    totalReviewPagesAllDocuments: 0,
    analyzingClauseVariance: false,
    loadingReviewData: false,
  })),
  on(WorkspacesActions.addWorkspaceDocuments, (state, {}) => ({
    ...state,
    addingWorkspaceDocuments: true,
    closeAddingWorkspaceDocumentsModal: false,
  })),
  on(WorkspacesActions.addWorkspaceDocumentsCancel, (state, {}) => ({
    ...state,
    addingWorkspaceDocuments: false,
    closeAddingWorkspaceDocumentsModal: false,
  })),
  on(WorkspacesActions.addWorkspaceDocumentsSuccess, (state, {}) => ({
    ...state,
    addingWorkspaceDocuments: false,
    closeAddingWorkspaceDocumentsModal: false,
  })),
  on(WorkspacesActions.addWorkspaceDocumentsFail, (state, {}) => ({
    ...state,
    addingWorkspaceDocuments: false,
    closeAddingWorkspaceDocumentsModal: false,
  })),
  on(WorkspacesActions.addWorkspaceDocumentsCancelled, (state, {}) => ({
    ...state,
    closeAddingWorkspaceDocumentsModal: true,
  })),
  on(WorkspacesActions.closeAddWorkspaceDocumentsModal, (state, {}) => ({
    ...state,
    closeAddingWorkspaceDocumentsModal: true,
  })),
  on(WorkspacesActions.clearAddWorkspaceDocumentsCancelled, (state, {}) => ({
    ...state,
    closeAddingWorkspaceDocumentsModal: false,
  })),
  on(GetReviewActions.setDocumentReviewDoneWithErrors, (state, { value }) => ({
    ...state,
    reviewDoneWithErrors: value,
  })),

  on(GetReviewActions.initializeReviewDataForDocuments, (state, { documentIds }) => ({
    ...state,
    currentReviewPageByDocumentId: documentIds.reduce<Record<string, number>>((acc, documentId) => {
      acc[documentId] = 1;
      return acc;
    }, {}),
    totalReviewPagesByDocumentId: documentIds.reduce<Record<string, number>>((acc, documentId) => {
      acc[documentId] = 1;
      return acc;
    }, {}),
    reviewedReviewPagesByDocumentId: documentIds.reduce<Record<string, number>>(
      (acc, documentId) => {
        acc[documentId] = 0;
        return acc;
      },
      {},
    ),
    pagedReviewDataByDocumentId: {},
    //totalReviewPagesAllDocuments: 0,
    totalReviewedPagesAllDocuments: 0,
    loadingReviewData: documentIds.length > 0,
    loadingReviewDataComplete: false,
  })),

  on(GetReviewActions.getPagedReviewData, (state, {}) => ({
    ...state,
    loadingReviewData: true,
    loadingReviewDataComplete: false,
  })),
  on(GetReviewActions.getPagedReviewDataSuccess, (state, { pagedReviewData }) => {
    const documentId = pagedReviewData.documentUniqueId;
    const currentPagedReviewData = state.pagedReviewDataByDocumentId[documentId];
    const totalReviewPagesByDocumentId = {
      ...state.totalReviewPagesByDocumentId,
      [documentId]: pagedReviewData.totalPages ?? 0,
    };
    const reviewedReviewPagesByDocumentId = {
      ...state.reviewedReviewPagesByDocumentId,
      [documentId]: Math.max(
        state.reviewedReviewPagesByDocumentId[documentId] ?? 0,
        pagedReviewData.pageNumber,
      ),
    };
    // const totalReviewPagesAllDocuments = Object.values(totalReviewPagesByDocumentId).reduce(
    //   (sum, pages) => sum + pages,
    //   0,
    // );
    const totalReviewedPagesAllDocuments = Object.values(reviewedReviewPagesByDocumentId).reduce(
      (sum, pages) => sum + pages,
      0,
    );

    const pagedReviewDataByDocumentId = {
      ...state.pagedReviewDataByDocumentId,
      [documentId]: {
        ...pagedReviewData,
        clauses: [...(currentPagedReviewData?.clauses ?? []), ...pagedReviewData.clauses],
      },
    };

    return {
      ...state,
      //clauses: [...(state.clauses ?? []), ...(pagedReviewData.clauses ?? [])],
      loadingReviewData: true,
      currentReviewPageByDocumentId: {
        ...state.currentReviewPageByDocumentId,
        [documentId]: pagedReviewData.nextPageNumber ?? pagedReviewData.pageNumber,
      },
      totalReviewPagesByDocumentId,
      reviewedReviewPagesByDocumentId,
      pagedReviewDataByDocumentId,
      //totalReviewPagesAllDocuments,
      totalReviewedPagesAllDocuments: totalReviewedPagesAllDocuments,
      //currentReviewPage: pagedReviewData.nextPageNumber ?? 1,
      //totalReviewPages: pagedReviewData.totalPages,
    };
  }),
  on(GetReviewActions.setPageNumberOfReviewData, (state, { documentId, pageNumber }) => ({
    ...state,
    currentReviewPageByDocumentId: {
      ...state.currentReviewPageByDocumentId,
      [documentId]: pageNumber,
    },
    //currentReviewPage: pageNumber,
  })),
  on(GetReviewActions.getPagedReviewDataComplete, (state, {}) => {
    const loadingReviewDataComplete =
      state.totalReviewPagesAllDocuments > 0 &&
      state.totalReviewedPagesAllDocuments >= state.totalReviewPagesAllDocuments;

    return {
      ...state,
      loadingReviewData: !loadingReviewDataComplete,
      loadingReviewDataComplete,
    };
  }),
);
